// removed by extract-text-webpack-plugin
module.exports = {"removePadding":"SearchUserByFullName__removePadding___1dfKg","removePaddingInnerDiv":"SearchUserByFullName__removePaddingInnerDiv___Nxr9s","buttonContainer":"SearchUserByFullName__buttonContainer___3_-rS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchUserByFullName/SearchUserByFullName.scss
// module id = 1530
// module chunks = 0